<template lang="pug">
  include ../../../../../pug/mixins/bem
  div
    +b.poll-title--centered.H1 {{ _('Дякуємо за ваші відповіді') }}
      +e.icon.svgicon-smile.SPAN
    +b.poll-text.P {{ _('Отримайте безкоштовний зразок смачної та корисної каші від європейського бренду Milupa для прикорму малюка.') }}
    +b.poll-milupa-promo
      +e.img.IMG(
        src='/static/images/milupa.png'
      )

    +b.poll-text--left.P {{ _('Для отримання зразка залиште свої контактні дані:') }}
    +b.poll-form-control.FORM(
      name="enter", 
      @submit.prevent='submit', 
      method='post', 
    )
      +e.inner
        
        input-group.poll-input--mini(
          type="text"
          id='full_name'
          name='full_name'
          :label='_("ПІБ")'
          v-validate="'required|min:2|max:100'"
          v-model="form.full_name"
        )
        input-group.poll-input--mini(
          type="text"
          id='phone'
          ref='phone'
          name='phone'
          :label='_("Номер телефону")'
          v-validate="'required|phone'"
          data-inputmask="+38(999)999-99-99"
          v-model="form.phone"
        )
        input-group.poll-input(
          type="text"
          id='city'
          ref='city'
          name='city'
          :label='_("Місто")'
          v-validate="'required'"
          v-model="city"
        )
          template(
            #customInput='{ error }'
          )
            multiselect(
              v-model="city",
              :options="cities.items",
              :multiple="false",
              :close-on-select="true",
              :show-labels="false",
              placeholder="",
              @search-change="asyncCity"
              @input='clearWarehouse'
              :searchable="true",
              name="city",
              :label='lang == "ru" ? "description_ru": "description"'
              :class="['poll-input__input',  {'poll-input__input--error': error }]",
              :rules="'required'",
            )
              template(
                #noResult=''
              )
                span {{ _('Ничего не найдено. Повторите свой запрос') }}
              template(
                #afterList=''
              )
                div(
                  v-observe-visibility="afterList" 
                  v-if="cities.pagination.next"
                )
        +b.poll-tips.P {{ _('Вкажіть номер відділення Нової Пошти, з якого вам буде зручно забрати посилку') }}        

        +b.poll-input--multiselect.INPUT-GROUP(
          type="text"
          id='warehouse'
          ref='warehouse'
          name='warehouse'
          :disabled='!city'
          :label='_("Відділення")'
          v-validate="'required'"
          v-model="warehouse"
        )
          template(
            #customInput='{ error }'
          )
            multiselect(
              v-model="warehouse",
              :options="warehouses.items",
              :disabled='!city'
              :multiple="false",
              :close-on-select="true",
              :show-labels="false",
              placeholder="",
              @search-change="asyncWarehouse"
              :searchable="true",
              name="warehouse",
              :label='lang == "ru" ? "description_ru": "description"'
              :class="['poll-input__input', 'poll-input__input--multiselect',  {'poll-input__input--error': error }]",
              :rules="'required'",
            )
              template(
                #noResult=''
              )
                span {{ _('Ничего не найдено. Повторите свой запрос') }}
              template(
                #afterList=''
              )
                div(
                  v-observe-visibility="afterListWarehouse" 
                  v-if="warehouses.pagination.next"
                )
        +b.poll-tips--mini.P {{ _('Вартість відправки зразка Новою Поштою оплачує ТОВ з ІІ “Нутриція Україна” ') }}
        +b.poll-checkboxes 
          +e.el--free(
          )
            +e.input.INPUT(
              type='checkbox',
              name='rules',
              id="rules2", 
              v-validate="'required'"
              v-model='form.can'
            )
            +e.label.LABEL(
              for='rules2'
              
            )
              +e.text.P  {{ _('Я даю згоду на обробку моїх персональних даних, погоджуюся з ') }}
                +e.link.A(:href='policy', target="_blank") {{ _('політикою конфіденційності') }}
                span &nbsp; {{ _('та умовами вступу в Nutricia Club! ') }} 
            span.poll-input__error(v-show="errors.has('rules')" ) {{ errors.first('rules') }}
    
        div(
          style='color: #dd4400', 
          v-if='errors.username'
        ): small(
          v-for='error in errors.username', 
          v-text='error'
        )
        +e.bottom
          +b.poll-btn.BUTTON(
            type='submit'
          ) {{ _('Надіслати') }}
        
</template>

<script>
import InputGroup from "./../../CustomInputGroup"
import VendorService from '@shared/services/vendor.js'
import { masking } from '@shared/utils/helpers'

const FIRST_PAGE_OFFSET = 0

export default {
  name: 'Form',
  components: {
    InputGroup
  },
  data() {
    return {
      policy: window.policy,
      lang: window.language,
      form: {
        full_name: '',
        phone: '',
        city: '',
        can: false,
      },
      error: '',
      city: '',
      cities: {
        items: [],
        pagination: {
          next: false,
        }
      },
      warehouse: '',
      warehouses: {
        items: [],
        pagination: {
          next: false,
        },
      },
      isLoading: false,
      city_query: '',
      warehouse_query: '',
    }
  },
  mounted() {
    this.asyncCity('')
    masking('phone', this)
  },
  methods: {
    clearWarehouse() {
      this.warehouse = ''
      this.asyncWarehouse("")
    },
    afterList(visible) {
      if (!visible) return
      this.asyncCity(this.city_query, true)
    },
    asyncCity(query, push) {
      this.isLoading = true
      this.city_query = query
      let offset = this.cities.pagination.offset + 
        this.cities.pagination.limit
      if (!push) offset = FIRST_PAGE_OFFSET

      VendorService.getCities(this.city_query, offset).then(({ data: { pagination, items } }) => {
        
        this.cities.pagination = pagination
        console.log(push);
        if (push) {
          this.cities.items.push(...items)
        } else {
          this.cities.items = items
        }
        console.log("🚀 ~ file: form.vue ~ line 175 ~ VendorService.getCities ~ pagination, items ", pagination, items )
        
        this.isLoading = false
      }, err => {
        
        this.isLoading = false
      })
    
    },
    afterListWarehouse(visible) {
      if (!visible) return
      this.asyncWarehouse(this.warehouse_query, true)
    },
    asyncWarehouse(query, push) {
      this.isLoading = true
      this.warehouse_query = query
      let offset = this.warehouses.pagination.offset + 
        this.warehouses.pagination.limit
      if (!push) offset = FIRST_PAGE_OFFSET

      VendorService.getWarehouses(this.city.ref, this.warehouse_query, offset).then(({ data: { pagination, items } }) => {
        this.warehouses.pagination = pagination
        console.log(push);
        if (push) {
          this.warehouses.items.push(...items)
        } else {
          this.warehouses.items = items
        }
        this.isLoading = false
      }, err => {
        
        this.isLoading = false
      })
    
    },
    submit() {
      this.$validator.validateAll().then(result => {
        const phone = document.getElementById('phone')
        if (phone) phone.dispatchEvent(new Event('input'))
        if (result) {
          this.form.address = `${this.city.description} ${this.warehouse.description}`
          this.next()
        }
      })
    },
    next() {
      let obj = {
        current: 'Success'
      }
      Object.keys(this.form).forEach(key => {
        obj[key] = this.form[key]
      })
      
      this.$emit('next', obj)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/poll/steps/form.vue